import { useEffect, useState } from 'react';
import { bulletinboardsApi } from 'apis/bulletinboards';
import { useDixaMessengerApi } from 'components/settings/components/sections/dixaMessenger/api/apiProvider';
/**
 * From the messengerId and bulletinId, fetch the correct bulletin
 *
 * @param param0
 * @returns UseLoadBulletinReturn
 */
export function useLoadBulletin({ messengerId, bulletinId, }) {
    const [isFetching, setIsFetching] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [boardId, setBoardId] = useState(null);
    const messengerApi = useDixaMessengerApi();
    const [fetchBulletin, { data: bulletinApiData, isFetching: fetchBulletinIsFetching, isError },] = bulletinboardsApi.useLazyReadBulletinQuery();
    useEffect(() => {
        setHasError(false);
        setIsFetching(true);
        messengerApi
            .fetch(messengerId)
            .then((settings) => {
            var _a, _b, _c;
            const boardId = (_c = (_b = (_a = settings.settings) === null || _a === void 0 ? void 0 : _a.integrations) === null || _b === void 0 ? void 0 : _b.bulletinBoard) === null || _c === void 0 ? void 0 : _c.boardId;
            if (!boardId)
                throw new Error('boardId not found');
            setBoardId(boardId);
            return boardId;
        })
            .then((boardId) => fetchBulletin({
            boardId,
            bulletinId,
        }))
            .then(() => setIsFetching(false))
            .catch(() => {
            setIsFetching(false);
            setHasError(true);
        });
    }, [messengerId, bulletinId, fetchBulletin, messengerApi]);
    return {
        isFetching: isFetching || fetchBulletinIsFetching,
        hasError: hasError || isError,
        bulletin: bulletinApiData || null,
        bulletinBoardId: boardId,
    };
}
